export default __webpack_public_path__ + "static/media/Frostfur.596a5974.jpg";